import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import { ExaminerFunction } from '../Assessment/Assessment.types';
export interface Tile {
  dashboardTiles: DashboardTile[];
}
export interface DashboardTile {
  id?: string;
  sampleAssessmentGroupName?: string;
  name?: string;
  tileType: TileType;
  sessionType: SessionType;
  tileState: TileState;
  assessmentSessionId: string;
  examTaskGroupName: string;
  examinerFunction: ExaminerFunction;
  examSheetId: string;
  isExamSheetConfigured: boolean;
  assessmentSessionName: string;
  examSheetName: string;
  examName: string;
  dashboardExamName: string;
  dashboardSessionName: string;
  dashboardSheetCode: string;
  assesmentSessionStartDate: null | string;
  assesmentSessionEndDate: null | string;
  assessmentSessionStateId: AssessmentSessionState;
  assessmentSessionProcesses: AssessmentSessionProcess[];
  sessionProcessStats: SessionProcessStats;
  sessionProcessSampleAssessmentGroupStats: SessionProcessSampleAssessmentGroupStats;
  isQualificationProcessActive: boolean;
  isControlProcessActive: boolean;
  sampleAssessmentSessionStateId: SampleAssessmentSessionState;
  isAnySpecialCaseInAssessmentSession?: boolean;
}
export interface AssessmentSessionProcess {
  assessmentSessionProcessTypeId: AssessmentSessionProcessTypeId;
  isCurrentProcess: boolean;
  isAccessible: boolean;
  startDate: null | string;
}
export interface SessionProcessStats {
  sendedBackTaskGroupSolutionCount: null;
  totalTaskGroupSolutionCount: number;
}

export interface SessionProcessSampleAssessmentGroupStats {
  sampleAssessmentRequiredSolutionsCountSum: number | null;
  sampleExamTaskGroupSolutionScoreAcceptanceStatusCzwoAssessed: number | null;
  sampleExamTaskGroupSolutionScoreAcceptanceStatusNone: boolean | null;
  sampleExamTaskGroupSolutionScoreAcceptanceStatusPzwoAccepted: number | null;
}

export enum TileType {
  E,
  PZE,
  PZE_RGZ,
  KGZ,
  KK,
  CZWO,
  PZWO,
}
export enum TileState {
  Active,
  Inactive,
  ReadOnly,
  Suspended,
}

export enum SessionType {
  AssessmentSession,
  SampleAssessmentSession,
}

export enum AssessmentSessionState {
  New = 1,
  Opened,
  Closed,
  Suspended,
}

export enum SampleAssessmentSessionState {
  Open,
  Closed,
  NotRequired,
}

export type DashboardType = 'assessment' | 'training';

export interface DataForExaminerTreeMap {
  sheetId: string;
  subject: string;
  isExamSheetConfigured: string;
  sheetCode?: string,
  assessmentSessionName?: string;
  assessmentSessionId?: string;
  isControlProcessActive?: string;
}